import type { CSSCustomProperties } from "@circleco/compass/components/MobileTopNav";

/**
 * `MobileShell.Header` remaps `--color-background-inverse`/`--color-text-
 * inverse` for its own badge - same tokens `Button`'s `variant="primary"`
 * reads - so a primary action here would otherwise inherit the community's
 * brand color on mobile only. Shadows all four back to Compass's un-remapped
 * values (`light.css`; no runtime dark theme yet) - the hover/active pair
 * is separate from the rest-state pair (not derived from it), so missing
 * either leaves that state to fall through to the branded value again, e.g.
 * unreadable text on hover.
 */
export const primaryActionToneFix: CSSCustomProperties = {
  "--color-background-inverse": "var(--color-grey-900)",
  "--color-background-inverse-hover": "var(--color-grey-700)",
  "--color-background-inverse-active": "var(--color-grey-800)",
  "--color-text-inverse": "var(--color-grey-50)",
};
